import 'theme.mobiscroll.scss';

import React, { useEffect } from 'react';

import { MantineProvider } from '@mantine/core';
import { applyThemeCssVariables } from 'utils/theme-vars';

import { lightTheme } from '../theme';

const ThemeProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const root = document.documentElement;
  root.style.setProperty('font-size', '14px');

  useEffect(() => {
    applyThemeCssVariables(lightTheme);
  }, []);

  return (
    <MantineProvider theme={lightTheme} withNormalizeCSS withGlobalStyles>
      {children}
    </MantineProvider>
  );
};

export default ThemeProvider;
